module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/N4R0nG/tc-custom/9781449423902.jpg?1737750951161",
      "alt": "This image is the cover for the book Pocket Posh 100 Classic Love Poems"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Pocket Posh 100 Classic Love Poems\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Find a hundred ways to say “I love you” with a heartwarming collection featuring poets from Shakespeare to Shelley. ")]), _c('br'), _c('br'), _c('i', [_vm._v("“If ever two were one, then surely we.” —Anne Bradstreet")]), _c('br'), _c('br'), _vm._v("Shakespeare’s sonnets; the elegant words of Robert Browning; the poignant works of Elizabeth Barrett Browning; the stirring poetry of Christina Rossetti—all are collected here in this celebration of romantic passion and deep abiding love. "), _c('br'), _c('br'), _vm._v("Emily Dickinson, Ralph Waldo Emerson, William Butler Yeats, Lord Byron, Keats, Wordsworth, Shelley, and other treasured poets provide meaningful, memorable ways to speak the language of the heart.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jennifer Fox\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jennifer Fox is a writer, reader, and lover of all types of poetry. She is a free spirit, music lover, peace seeker, traveler, and yoga instructor. Jennifer lives in Albuquerque, New Mexico, with her husband, rescued basset hounds, and geriatric cats.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0